export class AcknowledgeDialogSettings {
  constructor(
    public title: string,
    public content: string
  ) {}
}
